<div class="wrapper" [ngClass]="{'isOpened': isOpened}">
  <fa-icon icon="times" class="close-icon" (click)="closeSidebar($event)"></fa-icon>
  <div class="sidebar-container" id="wm-sidebarright-container"></div>
</div>
